import { NetworkStatus } from '@cbridge-utils/network';
import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { isDetailsSidebarShownSelector, detailsSidebarStoreSelector, SidebarOpenMode } from '@cbridge-packages/details-sidebar';
import { streamListSelector } from '@cbridge-packages/stream';

export const streamDetailsSidebarPropsSelector = createCachedSelector(
  [
    isDetailsSidebarShownSelector,
    path(detailsSidebarStoreSelector).mode(),
    path(streamListSelector).networkStatus(),
    path(streamListSelector).list.length(),
  ],
  (isSidebarShown, mode, networkStatus, count) => {
    const isCreateMode = mode === SidebarOpenMode.Create;
    const isDataLoaded = (networkStatus === NetworkStatus.Done || count > 0);

    return {
      isShown: isSidebarShown && (isCreateMode || isDataLoaded),
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
